import * as metaStateUtils from '../../../../store/util/metaStateUtils';
import * as orderConstants from '../orderConstants';

import saveOrderReducer from './saveOrderReducer';
import saveOrderSummaryReducer from './saveOrderSummaryReducer';


const INITIAL_STATE = metaStateUtils.withDefaultMetaState({
    orderSummaries: {},
    orders: {}
});


export default (state = INITIAL_STATE, action) => {

    switch (action.type) {

        case orderConstants.ACTION_ORDER_LOADED:

            return saveOrderReducer(state, action.payload);

        case orderConstants.ACTION_ORDER_SUMMARY_LOADED:

            return saveOrderSummaryReducer(state, action.payload);


        default:

            return state;
    }
};
